/**
 * overview: how a chart point of each widget maps back to the rows behind it,
 * for the conversations drill-down. Same filtering as the widget's loader.
 *
 * None: the four overview figures draw no chart, so nothing on them drills
 * (the prototype's `SummaryKpiCards` never took `onViewDetails`).
 */
import type { DrillResolvers } from './types';

export const overviewDrillResolvers: DrillResolvers = {};
